import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GlobalAppState {
  loading: boolean;
}

const initialState: GlobalAppState = {
  loading: false,
};

const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setGlobalState: (state, action: PayloadAction<GlobalAppState>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setGlobalState } = globalSlice.actions;
export default globalSlice.reducer;
